module.exports = __webpack_public_path__ + "static/media/sf-massage.e20c152b.jpg";